/**
 * Created by abbeymart on 2016-12-26.
 */
import type { RouteRecordRaw } from 'vue-router';

export const techGuideRoutes: Array<RouteRecordRaw> = [
  {
    path: '/techGuide',
    name: 'techGuide',
    component: () => import('pages/central/common/TechGuide.vue'),
    meta: {
      title: 'Technical Guides & Specifications',
    },
  },
];
